import type { PropsWithChildren } from 'react';

import { VFlex, cn } from '@/package';

const ContainerHeader = ({ children }: PropsWithChildren) => {
  return (
    <VFlex className="relative z-10 w-full shadow-sm" justify="center">
      <div
        className={cn(
          'w-[calc(100vw-var(--spacing-sidebar))] min-w-[calc(var(--container-md)-var(--spacing-sidebar))]',
          'px-8',
          '@xl:w-[calc(120rem-var(--spacing-sidebar))]',
        )}
      >
        {children}
      </div>
    </VFlex>
  );
};

export default ContainerHeader;
